import { tapFlashError, tapFlashSuccess } from '../../generic/flash-messages';
import { applicableDiscount } from '../../invoices/utils';
import api from '../../REST/api';
import { markUiAction } from '../../utils/create-ui-action';

export const loadBookingEntries = opportunityId => dispatch =>
  dispatch(
    markUiAction({
      type: loadBookingEntries.toString(),
      payload: api
        .getBookingEntries({ search: { opportunityId, unassigned: 1 } })
        .then(
          tapFlashSuccess(dispatch, 'Booking entries loaded successfully'),
          tapFlashError(dispatch),
        ),
    }),
  );

loadBookingEntries.toString = () => 'booking-entries/load-booking-entries';

export const addBookingEntry = bookingEntry => dispatch =>
  dispatch(
    markUiAction({
      type: addBookingEntry.toString(),
      payload: api
        .addBookingEntry({
          data: bookingEntry,
        })
        .then(
          tapFlashSuccess(dispatch, 'Booking entry created'),
          tapFlashError(dispatch),
        ),
    }),
  );

addBookingEntry.toString = () => 'booking-entries/add-booking-entry';

export const deleteBookingEntry = id => dispatch =>
  dispatch(
    markUiAction({
      type: deleteBookingEntry.toString(),
      payload: api
        .destroyBookingEntry({ id })
        .then(
          tapFlashSuccess(dispatch, 'Booking entry deleted successfully'),
          tapFlashError(dispatch),
        ),
      meta: { id },
    }),
  );

deleteBookingEntry.toString = () => 'booking-entries/delete-booking-entry';

export const updateBookingEntry = (id, patch) => dispatch =>
  dispatch(
    markUiAction({
      type: updateBookingEntry.toString(),
      payload: api
        .patchBookingEntry({
          id,
          data: patch,
        })
        .then(
          tapFlashSuccess(dispatch, 'Booking entry updated successfully'),
          tapFlashError(dispatch),
        ),
    }),
  );

updateBookingEntry.toString = () => 'booking-entries/update-booking-entry';

export const generateBookingEntries = opportunityId => dispatch =>
  dispatch(
    markUiAction({
      type: generateBookingEntries.toString(),
      payload: api
        .generateBookingEntries(opportunityId)
        .then(
          tapFlashSuccess(dispatch, 'Booking entries are being generated'),
          tapFlashError(dispatch),
        ),
    }),
  );

generateBookingEntries.toString = () =>
  'booking-entries/generate-booking-entries';

export const applyDiscountToMatchBudget = (budget, entries) => dispatch => {
  let remainingDiscount = applicableDiscount(budget, entries);
  const changedEntries = [];

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < entries.length; i++) {
    if (remainingDiscount === 0) {
      break;
    }
    const entry = entries[i];
    const possibleDiscount = entry.debitAmount - entry.discount;
    const discount = Math.max(0, Math.min(possibleDiscount, remainingDiscount));
    remainingDiscount -= discount;

    if (discount > 0) {
      changedEntries.push({
        ...entry,
        discount: entry.discount + discount,
      });
    }
  }

  changedEntries.forEach(entry =>
    dispatch({
      type: applyDiscountToMatchBudget.toString(),
      payload: api
        .patchBookingEntry({
          id: entry.id,
          data: { discount: entry.discount },
        })
        .then(
          tapFlashSuccess(
            dispatch,
            'Discount to Booking Entry applied successfully',
          ),
          tapFlashError(dispatch),
        ),
    }),
  );
};

applyDiscountToMatchBudget.toString = () =>
  'booking-entries/apply-discount-to-match-budget';
